// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"62b49f59","434":"ec0e9e8e","813":"434fc691"}[chunkId] + ".chunk.css";
};